module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sekundaerlogo_postale_innlandet_pos.5b22eee8.png";